module.exports = __webpack_public_path__ + "bundle/assets/loading-clock.b1eaedba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/wayfinding/assets/loading-clock.svg
// module id = 62
// module chunks = 0